package com.crowpay.views.components

import com.crowpay.utils.existsDefaultFalse
import com.crowpay.utils.renderDollars
import com.crowpay.views.theming.body
import com.crowpay.views.theming.bodyBold
import com.crowpay.views.theming.greySeparator
import com.lightningkite.kiteui.models.dp
import com.lightningkite.kiteui.models.rem
import com.lightningkite.kiteui.reactive.ReactiveContext
import com.lightningkite.kiteui.reactive.Readable
import com.lightningkite.kiteui.reactive.invoke
import com.lightningkite.kiteui.views.ViewModifiable
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.direct.RowOrCol
import com.lightningkite.kiteui.views.direct.TextView
import com.lightningkite.kiteui.views.direct.col
import com.lightningkite.kiteui.views.direct.row
import com.lightningkite.kiteui.views.expanding


fun ViewWriter.keyString(key: String, value: String?) =
    row {
        spacing = 0.5.rem
        exists = value != null
        bodyBold("$key:")
        expanding - body {
            content = value ?: ""
        }
    }


fun ViewWriter.keyString(key: String, value: ReactiveContext.() -> String?) =
    row {
        spacing = 0.5.rem
        existsDefaultFalse { value() != null }
        bodyBold {
            content = "$key:"
        }
        expanding - body {
            ::content { value() ?: "" }
        }
    }

fun ViewWriter.keyMoney(key: String, value: ReactiveContext.() -> Long?) = keyString(key) { value()?.renderDollars() }

fun ViewWriter.keyView(key: String, view: RowOrCol.() -> ViewModifiable) =
    row {
        spacing = 0.5.rem
        bodyBold("$key:")
        expanding - view()
    }

fun ViewWriter.keyString(key: Readable<String>, value: ReactiveContext.() -> String?) {
    row {
        bodyBold {
            ::content{ "${key()}:" }
        }
        expanding - body {
            ::content { value() ?: "" }
        }
    }
}

fun ViewWriter.tableEntry(key: String, view: RowOrCol.() -> ViewModifiable) = col {
    spacing = 1.dp
    row {
        spacing = 0.5.rem
        expanding - body(key)
        view()
    }
    greySeparator()
}

fun ViewWriter.tableEntryString(key: String, value: String?) = tableEntry(key) { body(value ?: "") }
fun ViewWriter.tableEntryString(key: String, value: ReactiveContext.() -> String?) = tableEntry(key) { body { ::content { value() ?: "" } } }
fun ViewWriter.tableEntryMoney(key: String, value: ReactiveContext.() -> Long) = tableEntryString(key) { value().renderDollars() }

fun htmlKeyValue(key: String, value: String) = "<strong>$key:</strong> $value"
fun TextView.inlineKeyValue(key: String, value: String) = setBasicHtmlContent(htmlKeyValue(key, value))
